<template>
    <div>
        <pointsSummaryCustomer v-show="tab == 'customer'" ref="pointsSummaryCustomer" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></pointsSummaryCustomer>
        <pointsSummaryDate v-show="tab == 'date'" ref="pointsSummaryDate" @setSummary="setSummary" @setExportData="setExportData"></pointsSummaryDate>
    </div>
</template>
<script>
import PointsSummaryDate from './Points_Summary_Date'
import PointsSummaryCustomer from './Points_Summary_Customer'
export default {
    name: "outstandingsSummary",
    data(){
        return{
            tab: "customer",
        }
    },
    components:{
        PointsSummaryDate, PointsSummaryCustomer
    },
    methods:{
        async handleCreditSummary(filterObj){
            this.tab = filterObj.summaryType
            if(this.tab == 'date'){
                this.$refs.pointsSummaryDate.setCreditSummary(filterObj);
            }else{
                await this.$refs.pointsSummaryCustomer.setCreditSummaryCustomer(filterObj);
            }
        }, 
        setSummary(data){
            this.$emit('setSummary', data)
        },
        setBalanceSummary(total){
            this.$emit('setBalanceSummary', total)
        },
        setExportData(data){
            this.$emit('setExportData', data)
        }
    }
}
</script>
